export default __webpack_public_path__ + "guide--raster-naip-in-studio-480-3718f14733d8302e9b49267e6add93cf.webp";